import { render, staticRenderFns } from "./PapelSignatario.vue?vue&type=template&id=28c3fd49"
import script from "./PapelSignatario.vue?vue&type=script&lang=js"
export * from "./PapelSignatario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports